import { render, staticRenderFns } from "./Podcasts.vue?vue&type=template&id=665224e2&scoped=true&"
import script from "./Podcasts.vue?vue&type=script&lang=js&"
export * from "./Podcasts.vue?vue&type=script&lang=js&"
import style0 from "./Podcasts.vue?vue&type=style&index=0&id=665224e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665224e2",
  null
  
)

component.options.__file = "Podcasts.vue"
export default component.exports